import { useTranslation } from 'react-i18next';
import { Heading } from '@lili/lili-frontend-common';
import { ControllerWrapper } from '@Hooks/index';
import { FieldError } from '@Components/inputs/FieldError';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { FundingSourceOption } from './FundingSourceOption';

interface FundingSourcesFormProps {
  selectedOptions: string[];
  optionsList: {
    value: string;
    getLabel: () => string;
    field: EddEmbeddedFields;
    placeholder: string;
  }[];
}

export const FundingSourcesForm = ({ selectedOptions, optionsList }: FundingSourcesFormProps) => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[16px]'>
      <Heading.H9>{t('organic.fundingSources.instruction')}</Heading.H9>

      <div className='flex flex-col gap-[16px]'>
        <ControllerWrapper name={EddEmbeddedFields.EDD_FUNDING_SOURCES_SELECTED}>
          {({ onChange, error }) => (
            <div className='flex flex-col gap-[16px] w-full'>
              {optionsList.map((option) => (
                <FundingSourceOption
                  id={option.value}
                  key={option.value}
                  option={option}
                  selectedOptions={selectedOptions}
                  onOptionChange={(optionValue) => {
                    // Toggle selection
                    const newSelection = selectedOptions.includes(optionValue)
                      ? selectedOptions.filter((item) => item !== optionValue)
                      : [...selectedOptions, optionValue];

                    onChange(newSelection);
                  }}
                />
              ))}
              <FieldError
                error={error}
                testId={`${EddEmbeddedFields.EDD_FUNDING_SOURCES_SELECTED}-error`}
              />
            </div>
          )}
        </ControllerWrapper>
      </div>
    </div>
  );
};
